import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const Setting_URL = `${API_URL}/settings`

export function get(params: any) {
  return axios.get(`${Setting_URL}`, {params})
}
